export default __webpack_public_path__ + "static/media/laundry1-beforeA-768w.266e14d0.webp";